<template>
    <b-modal v-if="selectedItems" id="modal-set-schedule-payment" title="Schedule for Payment" v-model="value"
             @ok="statusSchedulePaymentOk" @cancel="statusSchedulePaymentCancel">
        <div class="row mb-1" v-if="isSingleSelectedItem">
            <div class="col">
                Amount Paid: (GBP) {{formatNumber(getPaymentAmount(selectedItems[0]))}}
            </div>
        </div>
        <div v-else class="row mb-1">
            <div class="col">
                <b-alert show variant="warning">You are setting the status of multiple items.  The details below will be recorded against each item.</b-alert>
            </div>
        </div>
        <div class="form-group">
            <label for="payment-ref">Payment Ref:</label>
            <input type="text" class="form-control" id="payment-ref" v-model="paymentRef">
        </div>
        <div class="form-group">
            <label for="payment-notes">Notes:</label>
            <textarea class="form-control" id="payment-notes" name="payment-notes" rows="4" cols="50" v-model="paymentNotes"></textarea>
        </div>
        <b-progress v-if="progressShow" :value="progressValue" :max="progressMax" show-value class="mb-3"></b-progress>
    </b-modal>
</template>
<script>
    
    import { mapActions, mapGetters } from 'vuex'
    export default {
        name: 'set-schedule-payment',
        props: {
            value: {
                required: true,
                type: Boolean
            },
            selectedItems: {
                required: true/*,
                type: Array*/
            },
            okOverride: {
                required: false,
                type: Function,
                default: null
            },
            cancelOverride: {
                required: false,
                type: Function,
                default: null
            }
        },
        data: () => {
            return {
                paymentRef: null,
                paymentNotes: null,

                progressShow: false,
                progressValue: 0,
                progressMax: 100
            }
        },
        computed: {
            showSchedulePaymentModal() {
                return this.value
            },
            isSingleSelectedItem() {
                return this.selectedItems.length == 1
            }
        },
        methods: {
            ...mapActions({
                setItemStatus: 'custPayments/setStatus'
            }),
            formatNumber(val) {
                if (isNaN(val))
                    return 0.00

                return (Math.round(val * 100) / 100).toFixed(2)
            },
            getExcessAmount(itm) {
                if (itm) {
                    if (itm.claimExcessCurrencyCode && itm.claimExcessCurrencyCode.length > 0 && itm.claimExcessAmount) {
                        return itm.claimExcessAmount
                    } else {
                        return itm.gadgetExcessAmount
                    }
                }
            },
            excessPaid(itm) {
                return itm.cardPaymentCurrencyCode && itm.cardPaymentAmount && itm.cardPaymentAmount > 0
            },
            getCoverLimit(itm) {
                if (itm) {
                    if (itm.hasOwnProperty("policyRatingTypeId") &&
                        itm.hasOwnProperty("policySAL") &&
                        itm.hasOwnProperty("policyCoverLimit") &&
                        itm.hasOwnProperty("gadgetValue")) {
                        if (itm["policyRatingTypeId"] == 1) {
                            return itm["gadgetValue"]
                        } else if (itm["policyRatingTypeId"] == 2) {
                            return itm["policySAL"]
                        } else {
                            return itm["policyCoverLimit"]
                        }
                    }
                } else {
                    return null;
                }
            },
            getPaymentAmount(itm) {
                let amount = null
                let coverLimit = this.getCoverLimit(itm)
                if (this.excessPaid(itm)) {
                    amount = itm.claimPaymentGross /*+ itm.cardPaymentAmount*/
                } else {
                    amount = itm.claimPaymentGross - this.getExcessAmount(itm)
                }

                if (coverLimit < amount)
                    return coverLimit

                return amount
            },
            async statusSchedulePaymentOk(bvModalEvent) {
                this.$emit('ok-clicked')
                if (this.okOverride != null)
                    await okOverride(bvModalEvent)
                else {
                    bvModalEvent.preventDefault()

                    if (this.isSingleSelectedItem) {
                        const selectedItem = this.selectedItems[0]
                        const payload = {
                            id: selectedItem.id,
                            statusId: 1003,
                            rv: selectedItem.rv,
                            paymentRef: this.paymentRef,
                            paymentNotes: this.paymentNotes
                        }

                        var response = await this.setItemStatus(payload)

                        this.$emit('set-item-status', { payload, response })
                    } else {
                        this.progressValue = 0
                        this.progressMax = this.selectedItems.length
                        this.progressShow = true
                        for (const itm of this.selectedItems)
                        {
                            const payload = {
                                id: itm.id,
                                statusId: 1003,
                                paymentRef: this.paymentRef,
                                paymentNotes: this.paymentNotes,
                                rv: itm.rv
                            }

                            var response = await this.setItemStatus(payload)
                            this.$emit('set-item-status', { payload, response })
                            this.progressValue += 1
                        };
                        this.progressShow = false
                    }
                }
                this.$emit('set-item-status-finished')
                this.reset()
            },
            async statusSchedulePaymentCancel(bvModalEvent) {
                this.$emit('cancel-clicked')
                if (this.cancelOverride != null) {
                    await cancelOverride(bvModalEvent)
                }

                this.reset()
            },
            reset() {
                this.paymentRef = null
                this.paymentNotes = null
                this.$emit('input', false)
            }
        }
    }
</script>